export enum EnvironmentEnum {
  Prod = 'prod',
  Dev = 'dev',
  Local = 'local',
}
